import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import MeetCait from "./sections/MeetCait";
import OurExpertise from "./sections/OurExpertise";
import WhyChooseUs from "./sections/WhyChooseUs";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <MeetCait />
      <OurExpertise />
      <WhyChooseUs />
      <ContactUs />
      <Footer />
    </div>;
}